<template>
  <PageWrapper :isDense="isDense" :isLoading="isLoading">
    <template #title>
      <span class="mt-2"> لیست شرکت کنندگان مسابقه </span>
    </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderAddUserToMatchDialog">
        افزودن کاربر به مسابقه
      </BButton>
    </template>
    <CustomTable
      v-if="matchUsers"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="matchUsers"
      @changePage="() => {}"
    >
      <template #userFullName="data">
        <b-link :to="`/users/${data.item.userId}`">
          {{ data.item.userFullName }}
        </b-link>
      </template>
      <template #score="data"> {{ data.item.score }} امتیاز </template>
      <template #userTotalAnswers="data">
        {{ data.item.userTotalAnswers }} سوال
      </template>
      <template #correctAnswers="data">
        {{ data.item.correctAnswers }} پاسخ
      </template>
      <template #isFinished="data">
        <BBadge
          style="font-weight: normal"
          :variant="data.item.isFinished ? 'success' : 'danger'"
        >
          {{ data.item.isFinished ? "بله" : "خیر" }}
        </BBadge>
      </template>
    </CustomTable>
    <AddUserToMatchDialog
      @refetch="refetch"
      :selectedMatch="selectedMatch"
    ></AddUserToMatchDialog>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    isDense: {
      type: Boolean,
      default: false,
    },
    selectedMatch: {
      type: Object,
    },
    matchUsers: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: false,
      tableColumns: [
        {
          key: "userId",
          label: "شناسه کاربر",
        },
        {
          key: "userFullName",
          label: "نام کاربر",
        },
        {
          key: "score",
          label: "امتیاز",
        },
        {
          key: "userTotalAnswers",
          label: "تعداد سوال های پاسخ داده شده",
        },
        {
          key: "correctAnswers",
          label: "تعداد پاسخ درست",
        },
        {
          key: "isFinished",
          label: "آزمون به اتمام رسیده",
          formatter: (val) => (val ? "بله" : "خیر"),
        },
      ],
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderAddUserToMatchDialog() {
      this.$bvModal.show("add-user-to-match-dialog");
    },
  },
  components: {
    AddUserToMatchDialog,
    PageWrapper,
    CustomTable,
    BButton,
    BLink,
    BBadge,
  },
};
import AddUserToMatchDialog from "@/views/components/Matches/AddUserToMatchDialog.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton, BLink, BBadge } from "bootstrap-vue";
</script>
